import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

const usePatients = () => {

    let navigate = useNavigate();

    const authState = useSelector((state) => state.authReducer);
    const roleId = authState.roleId;

    const actions = {
        add: () => navigate("/pacientes/nuevo-paciente"),
        edit: (id) => navigate(`/pacientes/${id}/editar-paciente`),
        delete: true,
    };

    return {
        actions,
        roleId
    }
};

export default usePatients;
